module.exports = __webpack_public_path__ + "static/people-9ac97ec5666242ca45ec52e00fcc7b73.png";